import React, { useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import Platforms from './components/Platforms';

const ExamplePage = () => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">Platforms</h3>
            <Button type="text" onClick={() => setModalVisible(true)}>Add Platform</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Platforms setModalVisible={(value) => setModalVisible(value)} modalVisible={modalVisible} />
      </Row>
    </div>
  )
};

export default ExamplePage;
